"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Example = exports.Describe = exports.Warning = exports.META_TYPE_EXAMPLE = exports.META_TYPE_DESCRIBE = exports.META_TYPE_WARNING = void 0;
exports.META_TYPE_WARNING = Symbol('gal:warning');
exports.META_TYPE_DESCRIBE = Symbol('gal:describe');
exports.META_TYPE_EXAMPLE = Symbol('gal:example');
const Warning = (txt) => Reflect.metadata(exports.META_TYPE_WARNING, txt);
exports.Warning = Warning;
const Describe = (txt) => Reflect.metadata(exports.META_TYPE_DESCRIBE, txt);
exports.Describe = Describe;
const Example = (txt) => Reflect.metadata(exports.META_TYPE_EXAMPLE, txt);
exports.Example = Example;
